var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header-container-fixed",class:{
      shrink: _vm.shrink
    }},[_c('h1',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.system.title))]),_c('div',{staticClass:"header-logo"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"src":_vm.system.logo,"alt":_vm.system.title,"title":_vm.system.title}})])],1),_c('div',{staticClass:"header-switch",on:{"click":function($event){return _vm.$emit('switch', !_vm.shrink)}}},[_c('i',{staticClass:"iconfont",class:{
          iconguanbi: _vm.shrink,
          icongengduo: !_vm.shrink
        }})])])])}
var staticRenderFns = []

export { render, staticRenderFns }